import Popper from '@popperjs/core';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/offcanvas';
import * as Modal from 'bootstrap/js/dist/modal';
import * as Tooltip from 'bootstrap/js/dist/tooltip';
import { utilities } from './utilities.js';

utilities.ready(() => {
	const supportsPassive = utilities.supportsPassive();

	// Init animate()
	utilities.animate();

	/**
	 * window.resize
	 */
	window.addEventListener('resize', () => {
		// console.log('resize');
	}, supportsPassive ? { passive: true } : false);

	/**
	 * window.scroll
	 */
	window.addEventListener('scroll', () => {
		// console.log('scroll');
	}, supportsPassive ? { passive: true } : false);

	/**
	 * Handle menu handle
	 */
	(() => {
		const menuContainer = document.getElementById('menu-container');
		const menu = document.getElementById('menu');
		const handle = document.querySelectorAll('.handle');

		if (!menu) {
			return;
		}

		menuContainer.addEventListener('hide.bs.offcanvas', event => {
			handle.forEach(item => {
				item.classList.remove('open');
			});
		});

		menuContainer.addEventListener('hidden.bs.offcanvas', event => {
			menu.classList.remove('open');
			menu.querySelectorAll('.sub-menu').forEach((item) => {
				item.classList.remove('open');
			});
		});

		menuContainer.addEventListener('show.bs.offcanvas', event => {
			handle.forEach(item => {
				item.classList.add('open');
			});
		});
	})();

	/**
	 * Handle menu
	 */
	(() => {
		const menu = document.getElementById('menu');
		const arrows = document.querySelectorAll('.link__arrow');
		const subMenuTitle = document.querySelectorAll('.sub-menu-back');

		if (!arrows) {
			return;
		}

		arrows.forEach(arrow => {
			arrow.addEventListener('click', (e) => {
				e.preventDefault();

				menu.querySelectorAll('.sub-menu').forEach((item) => {
					item.classList.remove('open');
				});
				
				arrow.parentNode.parentNode.querySelector('.sub-menu').classList.add('open');
				menu.classList.add('open');
			});
		});

		subMenuTitle.forEach(item => {
			item.addEventListener('click', (e) => {
				e.preventDefault();

				menu.classList.remove('open');

				setTimeout(() => {
					item.parentNode.classList.remove('open');
				}, 300);
			})
		});
	})();

	/**
   * Generic Slider
   */
	utilities.sliders();

	/**
   * Thumbnails Slider
   */
	utilities.thumbnailSliders();

	/**
	 * Resources
	 */
	(() => {
		const resources = [
			{action: 'case_studies', container: 'case-studies'},
			{action: 'blog', container: 'blog'},
			{action: 'inspirations', container: 'inspirations'},
			{action: 'testimonials', container: 'testimonials'},
		];

		resources.forEach((resource) => {
			const container = document.getElementById(resource.container);
			const categoryItems = document.querySelectorAll('.category');

			if (!container) {
				return;
			}

			utilities.more({ action: resource.action });
			categoryItems.forEach((category) => {
				category.addEventListener('click', (e) => {
					e.preventDefault();

					categoryItems.forEach((c) => {
						c.classList.remove('active');
					});

					category.classList.add('active');

					utilities.getItems({ action: resource.action, category: +e.target.dataset.id }, (data) => {
						scroll({top: 0, behavior: 'smooth'});
						container.innerHTML = data;
						utilities.animate();
						utilities.more({ action: resource.action, category: +e.target.dataset.id });
					});
				});
			});
		});
	})();

	/**
	 * Inspiration modal
	 */
	
	function inspirationsModal() {
		const inspirations = document.querySelectorAll('.inspiration');

		if (!inspirations) {
			return;
		}

		document.addEventListener('click', (e) => {
			const inspiration = e.target.closest('.action--inspiration');

			if (!inspiration) {
				return;
			}

			e.preventDefault();
			const modalElement = document.getElementById('modal--inspiration');
			const modal = new Modal(modalElement);
			const form_id = modalElement.dataset.id;
			const productCategory = inspiration.dataset.productCategory ? inspiration.dataset.productCategory : false;
			const productCategoryLink = inspiration.dataset.productCategoryLink ? inspiration.dataset.productCategoryLink : false;
			const productCategoryPreselect = inspiration.dataset.productCategoryPreselect ? inspiration.dataset.productCategoryPreselect : false;
			const productOption = inspiration.dataset.productOption ? inspiration.dataset.productOption : false;
			const printType = inspiration.dataset.printType;
			const brand = inspiration.dataset.brand;
			const interestField = document.getElementById('input_1_8');
	
			modalElement.querySelector('.modal__description').innerHTML = `
				<h2 class="display-3 pe-16 pe-xxl-18 mb-2">${brand}</h2>
				${productCategory ? `<p class="mb-0 mt-2"><strong>Product Category:</strong> ${productCategoryLink ? `<a href="${productCategoryLink}">${productCategory}</a>` : `${productCategory}`}</p>` : ''}
				${productOption ? `<p class="mb-0 mt-2"><strong>Product Option:</strong> ${productOption}</p>` : ''}
				${printType ? `<p class="mb-0 mt-2"><strong>Print Type:</strong> ${printType}</p>` : ''}
			`;
			
			if (productCategoryPreselect) {
				interestField.value = productCategoryPreselect;
			}
			
			utilities.handleFormInterest();

			jQuery(document).trigger('gform_post_render', [form_id, 1]);
			jQuery(document).bind('gform_post_render', (e, form_id) => {
				utilities.handleFormInterest();
				const form = document.getElementById('gform_1');

				if (form.length === 0) {
					return;
				}

				const interest = document.getElementById('input_1_8');
				const quantity = document.getElementById('input_1_10');
				const message = document.getElementById('qty-message');
				
				if (message) {
					message.remove();
				}

				if (interest.value === '') {
					quantity.setAttribute('min', 0);
					quantity.value = '';
					if (message) {
						message.remove();
					}
					return;
				}
		
				// if (interest.value === 'Inspirations') {
				// 	quantity.setAttribute('min', 0);

				// 	if (quantity.value === '') {
				// 		quantity.value = 5000;
				// 	}

				// 	if (message) {
				// 		message.remove();
				// 	}
				// 	return;
				// }

				const index = app.quantities.findIndex(entry => entry.title === interest.value);

				if (interest.value !== 'Inspirations' && interest.value !== 'Services' && interest.value !== '' && app.quantities[index].minimum_qty) {
					quantity.setAttribute('min', app.quantities[index].minimum_qty);
				
					if (quantity.value === '') {
						quantity.value = app.quantities[index].preset_qty ? app.quantities[index].preset_qty : app.quantities[index].minimum_qty;
					}
				}

				if (message) {
					message.remove();
				}
				
				interest.insertAdjacentHTML('afterend', utilities.quantitiesTemplate(app.quantities[index]));
			});

			modal.show();
		});
	};

	inspirationsModal();

	/**
	 * Expert help modal
	 */
	(() => {
		const page = document.querySelector('.page-template-template-inspirations');

		if (!page) {
			return;
		}

		let timer;
		const stopTimer = () => {
			clearTimeout(timer);
			document.removeEventListener('click', stopTimer);
		}

		document.addEventListener('click', stopTimer, {once: true});

		timer = setTimeout(() => {
			const modalElement = document.getElementById('modal--expert-help');
			const modal = new Modal(modalElement);
			modal.show();
			document.removeEventListener('click', stopTimer);
		}, 60000);
	})();

	/**
   * Glossary
   */

	/**
	 * Handle history back button
	 */
	(function () {
		const backButtons = document.querySelectorAll('.action-back');

		if (backButtons.length === 0) {
			return;
		}

		backButtons.forEach(button => {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				history.back();

				if (e.persisted) {
					// The page is restored from BFCache, set up a new connection.
					port = chrome.runtime.connect();
				}
			});
		});
	})();

	/**
	 * preventDefault() for ontouchmove event
	 */ 
	document.body.addEventListener('touchmove', e => {
		if (e.touches.length > 1) {
			e.preventDefault();
			e.stopImmediatePropagation();
		}
	}, true);

  /**
   * Filter search functionallity
   */
  (function () {
		const searchText = document.getElementById('filter__search');
    const glossaryTerms = document.querySelectorAll('.glossary-term');
    const glossaryIndex = document.querySelector('.glossary-index');
    let animating = false;
  
    if (!searchText || !glossaryTerms) {
      return;
		}

		['keyup', 'empty'].forEach(event => {
			searchText.addEventListener(event, e => {
				const value = searchText.value;
				const filter = document.getElementById('alphabet-filter');
				const noResults = document.getElementById('no-results');
				const offset = document.querySelector('.header').getBoundingClientRect().height;

				if (utilities.scrollTop(window) !== offset && !animating) {
					animating = true;
		
					if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
						window.scrollTo(0, 0);
						animating = false;
					} else {
						window.scrollTo(0, 0);
						//page.stop().animate({ scrollTop: offset }, 'fast', function () {
							animating = false;
						//});
					}
				}

				glossaryTerms.forEach(term => {
					const divider = term.querySelector('.glossary-divider');

					term.classList.remove('result');
					term.style.display = 'none';

					if (divider) {
						divider.style.display = '';
					}
				});

				glossaryIndex.style.display = 'none';

				if (value === '') {
					filter.style.opacity = 1;
					filter.style.pointerEvents = 'auto';
					glossaryIndex.style.display = '';

					glossaryTerms.forEach(term => {
						term.classList.remove('result');
						term.style.display = '';
					});

					noResults.classList.remove('d-block');
					noResults.classList.add('d-none');
				}

				if (value !== '') {
					const filteredTerms = [...glossaryTerms].filter((element) => {
						if (element.querySelector('h3').textContent.toUpperCase().includes(value.toUpperCase())) {
							return element.querySelector('h3').closest('.glossary-term');
						}
					});

					filter.style.opacity = 0.3;
					filter.style.pointerEvents = 'none';		

					filteredTerms.forEach(term => {
						term.classList.add('result');
						term.style.display = '';
						term.parentNode.style.display = '';
					});
		
					if (filteredTerms.length !== 0) {
						noResults.classList.remove('d-block');
						noResults.classList.add('d-none');
					} else {
						noResults.classList.remove('d-none');
						noResults.classList.add('d-block');
					}
				}
			});
		});
  })();

  /**
   * Add `sticky-filter` class to .filter
   */
  (() => { 
		const filter = document.getElementById('filter');

		if (!filter) {
			return;
		}

		const headerHeight = document.querySelector('.header').getBoundingClientRect().height;
		const breadcrumbsHeight = document.querySelector('.breadcrumbs').parentNode.getBoundingClientRect().height;
		const pageHeaderHeight = document.querySelector('.page-header').getBoundingClientRect().height;
		const filterOffset = pageHeaderHeight + breadcrumbsHeight;
		
		if (utilities.scrollTop(window) >= filterOffset - headerHeight) {
			document.body.classList.add('sticky-filter');
		}

		window.addEventListener('scroll', () => {
			if (utilities.scrollTop(window) >= filterOffset - headerHeight) {
				document.body.classList.add('sticky-filter');
			} else {
				document.body.classList.remove('sticky-filter');
			}
		}, supportsPassive ? { passive: true } : false);
	})();

	/**
   * Scroll to term
   */
	(() => {
		const filter = document.getElementById('filter');
		
		if (!filter) {
			return;
		}
		
		filter.querySelectorAll('a').forEach(letter => {
			letter.addEventListener('click', e => {
				e.preventDefault();
				const anchor = e.target.getAttribute('href');
				const glossaryIndex = document.getElementById(anchor.substring(1));
				window.scrollTo(0, utilities.offset(glossaryIndex).top - (window.innerWidth > 1199.98 ? 246 : (window.innerWidth > 991.98 ? 172 : 205)));
			});
		});
  })();
	
	/**
	 * Tooltips
	 */
	(() => {
		const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
		const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
			return new Tooltip(tooltipTriggerEl);
		});
	})();

	/**
	 * RFQ form
	 */
	(() => {
		const actions = document.querySelectorAll('.action--rfq');

		if (!actions) {
			return;
		}

		actions.forEach((action) => {
			action.addEventListener('click', (e) => {
				e.preventDefault();
				const modalElement = document.getElementById('modal--rfq');
				const modal = new Modal(modalElement);
				const interest = e.target.dataset.interest ? e.target.dataset.interest : false;
				const preselectedService = e.target.dataset.preselectedService ? e.target.dataset.preselectedService : false;
				const interestField = document.getElementById('input_1_8');
				const serviceField = document.getElementById('input_1_26');

				if (interest) {
					const name = document.getElementById('form__rfq__interest');
					
					if (name) {
						name.innerText = interest;
					}
				}

				if (preselectedService) {
					interestField.value = 'Services';
					serviceField.value = preselectedService;
					modalElement.querySelector('.modal-title').innerHTML = 'Get Started';
				}

				utilities.handleFormInterest();

				jQuery(document).bind('gform_post_render', (e, form_id) => {
					utilities.handleFormInterest();
					const form = document.getElementById('gform_1');

					if (form.length === 0) {
						return;
					}

					const interest = document.getElementById('input_1_8');
					const quantity = document.getElementById('input_1_10');
					const message = document.getElementById('qty-message');

					if (interest.value === '') {
						quantity.setAttribute('min', 0);
						quantity.value = '';
						if (message) {
							message.remove();
						}
						return;
					}
			
					// if (interest.value === 'Inspirations') {
					// 	quantity.setAttribute('min', 0);

					// 	if (quantity.value === '') {
					// 		quantity.value = 5000;
					// 	}

					// 	if (message) {
					// 		message.remove();
					// 	}
					// 	return;
					// }

					if (interest.value === 'Services') {
						quantity.setAttribute('min', 0);

						if (message) {
							message.remove();
						}
						return;
					}

					const index = app.quantities.findIndex(entry => entry.title === interest.value);

					if (interest.value !== 'Inspirations' && interest.value !== 'Services' && interest.value !== '' && app.quantities[index].minimum_qty) {
						quantity.setAttribute('min', app.quantities[index].minimum_qty);
					
						// if (quantity.value === '') {
						// 	quantity.value = app.quantities[index].minimum_qty;
						// }

						if (quantity.value === '') {
							quantity.value = app.quantities[index].preset_qty ? app.quantities[index].preset_qty : app.quantities[index].minimum_qty;
						}
					}

					if (message) {
						message.remove();
					}
					
					interest.insertAdjacentHTML('afterend', utilities.quantitiesTemplate(app.quantities[index]));
				});

				modal.show();
			});
		});
	})();

	/**
	 * Contact form
	 */
	(() => {
		const actions = document.querySelectorAll('.action--contact');

		if (!actions) {
			return;
		}

		actions.forEach((action) => {
			action.addEventListener('click', (e) => {
				e.preventDefault();
				const modalElement = document.getElementById('modal--contact');
				const modal = new Modal(modalElement);
				modal.show();
			});
		});
	})();

	/**
	 * Services form
	 */
	// (() => {
	// 	const actions = document.querySelectorAll('.action--services');

	// 	if (!actions) {
	// 		return;
	// 	}

	// 	actions.forEach((action) => {
	// 		action.addEventListener('click', (e) => {
	// 			e.preventDefault();
	// 			const modalElement = document.getElementById('modal--services');
	// 			const modal = new Modal(modalElement);
				

	// 			const interestField = document.getElementById('input_1_8');
	// 			console.log(interestField);
				
	// 			//if (productCategoryPreselect) {
	// 				interestField.value = 'Services';
	// 			//}
	// 			modal.show();
	// 		});
	// 	});
	// })();

	/**
	 * Help me choose
	 */
	(() => {
		const actions = document.querySelectorAll('.action--help-me-choose');

		if (!actions) {
			return;
		}

		actions.forEach((action) => {
			action.addEventListener('click', (e) => {
				e.preventDefault();
				const forms = document.getElementById('forms');
				const form_id = e.target.dataset.form;
				forms.style.display = 'block';
				document.getElementById('tab-' + form_id).checked = true;
			});
		});
	})();

	/**
	 * Show all reviews
	 */
	(() => {
		const btn = document.getElementById('reviews__show');

		if (!btn) {
			return;
		}

		btn.addEventListener('click', (e) => {
			e.preventDefault();

			const hidden = document.getElementById('reviews__hidden');
			hidden.classList.add('show');
			btn.classList.add('d-none');
		});
	})();

});